var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('deliver-print-order',{ref:"orders",on:{"clearDetails":_vm.clearDetails,"showDetails":_vm.showDetails}}),_c('deliver-print-detail',{ref:"details"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }